import { useAppStore } from '../stores/app';
import { DEMO_TENANT_CONFIG } from '../demo/demo-auth';

/**
 * usePermissions - Centralized RBAC logic for demo mode access control.
 *
 * In production (non-demo), all permissions return true.
 * In demo mode, permissions depend on the demo role.
 */
export function usePermissions() {
  const store = useAppStore();

  function canMutate(entityId?: string): boolean {
    if (!store.isDemoMode) return true;
    // Demo mode is used for UI/testing, and we treat "tenant" + "accountant" as
    // read-only roles. Only landlord can create/update/void records.
    if (store.demoRole === 'landlord') return true;
    void entityId; // preserved param for callsites; intentionally unused
    return false;
  }

  function canSeeAdminControls(): boolean {
    if (!store.isDemoMode) return true;
    return store.demoRole !== 'tenant';
  }

  function canRecordPayment(entityId?: string): boolean {
    // Demo tenant is allowed to create payments (for their own lease only).
    if (!store.isDemoMode) return true;
    if (store.demoRole === 'landlord') return true;
    if (store.demoRole === 'tenant') {
      return !!entityId && entityId === DEMO_TENANT_CONFIG.leaseId;
    }
    return false;
  }

  return { canMutate, canSeeAdminControls, canRecordPayment };
}
